module.exports = __webpack_public_path__ + "img/icon-store-competitor.e9315aba.svg";